import type { Observable } from 'rxjs';

import type { MonthlyStatementLayout } from './types';

export abstract class LayoutSource {
  abstract getLayout(): Observable<MonthlyStatementLayout>;
}
